<template>
  <div class="noResult">
    <div class="noResult__arrow">
      <img class="noResult__arrow--img" src="@/assets/images/arrow.png" />
    </div>
    <video autoplay loop class="noResult__video">
      <source src="@/assets/images/create-project-anim.mp4" type="video/mp4" />
    </video>
    <p class="empty-state-text">
      {{ text }}
    </p>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
const showArrow = ref(false)
const prop = defineProps({
  text: String
})
onMounted(() => {
  const arrow = document.querySelector('.noResult__arrow')
  setTimeout(() => {
    arrow.style.opacity = 1
  }, 3000)
})
</script>
<style lang="scss" scoped>
.noResult {
  padding: 50px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  &__video {
    width: 550px;
    z-index: -1;
  }
  &__arrow {
    @include desktop {
      display: initial;
      opacity: 0;
    }
    display: none;
    position: absolute;
    top: -70px;
    right: 250px;
    animation: bounceIn 1s 2.5s;
    &--img {
      transform: translateY(-5%);
      animation: float 2s infinite 1s;
      transition: ease 0.5s;
    }
    @keyframes bounceIn {
      0% {
        transform: scale(0.1);
        opacity: 0;
      }

      60% {
        transform: scale(1.05);
        opacity: 1;
      }

      100% {
        transform: scale(1);
      }
    }
    @keyframes float {
      0% {
        transform: translateY(-5%);
        transition: ease 0.5s;
      }
      50% {
        transform: translateY(5%);
        transition: ease 0.5s;
      }
    }
  }
}
.empty-state-text {
  color: #959ba5;
  font-weight: 500;
  font-size: 1.5rem;
}
</style>
